import { render, staticRenderFns } from "./OConfirmationModal.vue?vue&type=template&id=26d36520"
import script from "./OConfirmationModal.vue?vue&type=script&lang=js"
export * from "./OConfirmationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports